import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import logo from '../images/logo.png';
import fbicon from '../images/fbicon.png';
import instaicon from '../images/instaicon.png';

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <nav className="bg-white text-black p-4 fixed top-0 w-full z-50 shadow-md">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <Link to="/">
          <img src={logo} alt="logo" className="w-24 cursor-pointer" />
        </Link>

        {/* Hamburger Menu Button */}
        <button
          onClick={toggleMenu}
          className="md:hidden text-black focus:outline-none"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
        </button>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-8 text-lg">
          {["Home", "Bestellen", "Contact", "Over Ons", "Foto's"].map((item) => {
            const path = `/${item.toLowerCase().replace(/\s+/g, '-')}`;
            const isActive = location.pathname === path;

            return (
              <li key={item}>
                <Link
                  to={path}
                  className={`hover:text-gray-400 cursor-pointer ${isActive ? 'font-bold text-red-900' : ''}`}
                >
                  {item}
                </Link>
              </li>
            );
          })}
        </ul>

        {/* Social Icons */}
        <div className="flex space-x-4">
          <Link to="https://www.instagram.com/hoeveslagerijdespycker/">
            <img src={instaicon} alt="instagram" className="w-6 h-6 cursor-pointer"/>
          </Link>
          <Link to="https://www.facebook.com/profile.php?id=100046447727671">
            <img src={fbicon} alt="facebook" className="w-6 h-6 cursor-pointer"/>
          </Link>
        </div>
      </div>

      {/* Mobile Dropdown Menu with Dynamic Space */}
      <div
        className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
          isMenuOpen ? 'py-4 h-auto opacity-100' : 'h-0 opacity-0'
        }`}
      >
        <div className="bg-white p-4 space-y-4">
          {["Home", "Bestellen", "Contact", "Over Ons", "Foto's"].map((item) => {
            const path = `/${item.toLowerCase().replace(/\s+/g, '-')}`;
            const isActive = location.pathname === path;

            return (
              <Link
                key={item}
                to={path}
                className={`block text-lg hover:text-gray-400 ${isActive ? 'font-bold text-red-600' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;